import { useState } from "react";
import { Button, Icon } from "semantic-ui-react";

import { DEALER_DOCUMENTATION_CATEGORIES } from "models";
import { AddEditDealerDocumentationModal, DealerDocumentationsFilters, DealersDocumentationTable } from "modules/DealerDocumentations/components";
import "modules/DealerDocumentations/DealerDocumentations.scss";

import type { DealerDocumentation } from "models";

const defaultDealerDocumentation = {
  id: 0,
  title: "",
  content: "",
  publish_date: String(new Date()),
  url: null,
  is_pinned: false,
  visible_to_mechanic: false,
  visible_to_all: false,
  category_id: DEALER_DOCUMENTATION_CATEGORIES.Manual,
  dealer_ids: [],
  dealer_location_ids: [],
  created_on: "",
  updated_on: "",
  created_by_id: 0,
  updated_by_id: 0
};

export const DealerDocumentations = () => {
  const [showAddEditDealerDocumentationModal, setShowAddEditDealerDocumentationModal] = useState<DealerDocumentation | null>(null);
  const handleSetShowAddEditDealerDocumentationModal = (documentation: DealerDocumentation | null) => setShowAddEditDealerDocumentationModal(documentation);

  return (
    <>
      <div className="DealerDocumentation">
        <div className="dealer-toolbar-container">
          <Button basic icon className="add-btn" onClick={() => handleSetShowAddEditDealerDocumentationModal(defaultDealerDocumentation)}>
            <Icon className="plus" />
          </Button>
          <DealerDocumentationsFilters />
        </div>
        <DealersDocumentationTable handleSetShowAddEditDealerDocumentationModal={handleSetShowAddEditDealerDocumentationModal} />
      </div>
      {showAddEditDealerDocumentationModal && (
        <AddEditDealerDocumentationModal
          documentation={showAddEditDealerDocumentationModal}
          handleSetShowAddEditDealerDocumentationModal={handleSetShowAddEditDealerDocumentationModal}
        />
      )}
    </>
  );
};
